import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { Search, Home, MessageSquare, Gamepad2, Settings, Keyboard, Globe, Users, Youtube, Music, Tv, Radio, Brain, Zap, Eye, Hand, Mic, MousePointer, Moon, Clock, Volume2, AlertTriangle, HelpCircle, FileText, Shield, CreditCard, Book, Code, Cookie, Lock, Trash2, MapPin } from "lucide-react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

interface RouteInfo {
  path: string;
  label: string;
  icon: React.ReactNode;
  protected: boolean;
}

const routes: { category: string; items: RouteInfo[] }[] = [
  {
    category: "ציבוריים (Public)",
    items: [
      { path: "/auth", label: "התחברות / הרשמה", icon: <Lock className="w-4 h-4" />, protected: false },
      { path: "/verify-email", label: "אימות אימייל", icon: <Lock className="w-4 h-4" />, protected: false },
      { path: "/landing", label: "דף נחיתה", icon: <Home className="w-4 h-4" />, protected: false },
      { path: "/pricing", label: "תמחור", icon: <CreditCard className="w-4 h-4" />, protected: false },
      { path: "/guide", label: "מדריך", icon: <Book className="w-4 h-4" />, protected: false },
      { path: "/api-docs", label: "תיעוד API", icon: <Code className="w-4 h-4" />, protected: false },
      { path: "/connect-caregiver", label: "חיבור מטפל", icon: <Users className="w-4 h-4" />, protected: false },
      { path: "/legal/terms", label: "תנאי שימוש", icon: <FileText className="w-4 h-4" />, protected: false },
      { path: "/legal/privacy", label: "מדיניות פרטיות", icon: <Shield className="w-4 h-4" />, protected: false },
      { path: "/legal/refund", label: "מדיניות החזרים", icon: <FileText className="w-4 h-4" />, protected: false },
    ],
  },
  {
    category: "ראשי (Main)",
    items: [
      { path: "/", label: "דף הבית", icon: <Home className="w-4 h-4" />, protected: true },
      { path: "/onboarding", label: "אונבורדינג", icon: <MapPin className="w-4 h-4" />, protected: true },
    ],
  },
  {
    category: "תקשורת (Communication)",
    items: [
      { path: "/communication", label: "לוח תקשורת", icon: <MessageSquare className="w-4 h-4" />, protected: true },
      { path: "/communication/actions", label: "פעולות AAC", icon: <MessageSquare className="w-4 h-4" />, protected: true },
      { path: "/communication/builder", label: "בונה לוחות", icon: <MessageSquare className="w-4 h-4" />, protected: true },
      { path: "/communication/builder/details", label: "פרטי לוח", icon: <MessageSquare className="w-4 h-4" />, protected: true },
      { path: "/keyboard", label: "מקלדת", icon: <Keyboard className="w-4 h-4" />, protected: true },
      { path: "/keyboard/actions", label: "פעולות מקלדת", icon: <Keyboard className="w-4 h-4" />, protected: true },
      { path: "/aac-keyboard", label: "מקלדת AAC", icon: <Keyboard className="w-4 h-4" />, protected: true },
      { path: "/translator", label: "מתרגם", icon: <Globe className="w-4 h-4" />, protected: true },
      { path: "/translator/language", label: "בחירת שפה", icon: <Globe className="w-4 h-4" />, protected: true },
      { path: "/ai-chat", label: "צ'אט AI", icon: <Brain className="w-4 h-4" />, protected: true },
    ],
  },
  {
    category: "אנשי קשר (Contacts)",
    items: [
      { path: "/contacts", label: "אנשי קשר", icon: <Users className="w-4 h-4" />, protected: true },
      { path: "/contacts/settings", label: "הגדרות אנשי קשר", icon: <Users className="w-4 h-4" />, protected: true },
      { path: "/contacts/compose", label: "כתיבת הודעה", icon: <Users className="w-4 h-4" />, protected: true },
    ],
  },
  {
    category: "מדיה (Media)",
    items: [
      { path: "/youtube", label: "יוטיוב", icon: <Youtube className="w-4 h-4" />, protected: true },
      { path: "/music", label: "מוזיקה", icon: <Music className="w-4 h-4" />, protected: true },
      { path: "/tv", label: "טלוויזיה", icon: <Tv className="w-4 h-4" />, protected: true },
      { path: "/radio", label: "רדיו", icon: <Radio className="w-4 h-4" />, protected: true },
    ],
  },
  {
    category: "בידור (Entertainment)",
    items: [
      { path: "/games", label: "משחקים", icon: <Gamepad2 className="w-4 h-4" />, protected: true },
    ],
  },
  {
    category: "בית חכם (Smart Home)",
    items: [
      { path: "/smarthome", label: "בית חכם", icon: <Zap className="w-4 h-4" />, protected: true },
      { path: "/smarthome/button", label: "עריכת כפתור", icon: <Zap className="w-4 h-4" />, protected: true },
    ],
  },
  {
    category: "שליטה (Control)",
    items: [
      { path: "/control", label: "שליטה", icon: <MousePointer className="w-4 h-4" />, protected: true },
      { path: "/control/eye-control", label: "שליטת עיניים", icon: <Eye className="w-4 h-4" />, protected: true },
      { path: "/control/eye-control/mapping", label: "מיפוי פעולות", icon: <Eye className="w-4 h-4" />, protected: true },
      { path: "/control/head-tracking", label: "מעקב ראש", icon: <Hand className="w-4 h-4" />, protected: true },
      { path: "/control/gaze-tracking", label: "מעקב מבט", icon: <Eye className="w-4 h-4" />, protected: true },
      { path: "/control/external-switch", label: "מתג חיצוני", icon: <Zap className="w-4 h-4" />, protected: true },
      { path: "/control/voice", label: "שליטה קולית", icon: <Mic className="w-4 h-4" />, protected: true },
      { path: "/control/mouth-gestures", label: "מחוות פה", icon: <Mic className="w-4 h-4" />, protected: true },
    ],
  },
  {
    category: "מערכת (System)",
    items: [
      { path: "/rest", label: "מנוחה", icon: <Moon className="w-4 h-4" />, protected: true },
      { path: "/time", label: "שעון", icon: <Clock className="w-4 h-4" />, protected: true },
      { path: "/volume", label: "עוצמת קול", icon: <Volume2 className="w-4 h-4" />, protected: true },
      { path: "/emergency", label: "חירום", icon: <AlertTriangle className="w-4 h-4" />, protected: true },
      { path: "/help", label: "עזרה", icon: <HelpCircle className="w-4 h-4" />, protected: true },
    ],
  },
  {
    category: "הגדרות (Settings)",
    items: [
      { path: "/settings", label: "הגדרות", icon: <Settings className="w-4 h-4" />, protected: true },
      { path: "/settings/voice/cloning", label: "שכפול קול", icon: <Mic className="w-4 h-4" />, protected: true },
      { path: "/settings/2fa", label: "אימות דו-שלבי", icon: <Lock className="w-4 h-4" />, protected: true },
      { path: "/settings/caregiver/delete", label: "מחיקת מטפל", icon: <Trash2 className="w-4 h-4" />, protected: true },
      { path: "/cookies", label: "הגדרות עוגיות", icon: <Cookie className="w-4 h-4" />, protected: true },
      { path: "/legal", label: "משפטי", icon: <FileText className="w-4 h-4" />, protected: true },
      { path: "/legal/cookies", label: "מדיניות עוגיות", icon: <Cookie className="w-4 h-4" />, protected: true },
    ],
  },
  {
    category: "Coming Soon",
    items: [
      { path: "/history", label: "היסטוריה", icon: <Clock className="w-4 h-4" />, protected: true },
      { path: "/calendar", label: "יומן", icon: <Clock className="w-4 h-4" />, protected: true },
      { path: "/news", label: "חדשות", icon: <FileText className="w-4 h-4" />, protected: true },
      { path: "/more", label: "עוד", icon: <FileText className="w-4 h-4" />, protected: true },
    ],
  },
];

export default function DevRoutes() {
  const location = useLocation();
  const [searchQuery, setSearchQuery] = useState("");

  const filteredRoutes = routes.map((category) => ({
    ...category,
    items: category.items.filter(
      (item) =>
        item.path.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.label.toLowerCase().includes(searchQuery.toLowerCase())
    ),
  })).filter((category) => category.items.length > 0);

  const totalRoutes = routes.reduce((acc, cat) => acc + cat.items.length, 0);
  const filteredCount = filteredRoutes.reduce((acc, cat) => acc + cat.items.length, 0);

  return (
    <div className="min-h-screen bg-background p-6" dir="rtl">
      <div className="max-w-4xl mx-auto space-y-6">
        {/* Header */}
        <div className="space-y-2">
          <h1 className="text-3xl font-bold text-foreground">🗺️ מפת נתיבים (Dev Routes)</h1>
          <p className="text-muted-foreground">
            כל הנתיבים הזמינים באפליקציה • {totalRoutes} נתיבים
          </p>
        </div>

        {/* Search */}
        <div className="relative">
          <Search className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
          <Input
            type="text"
            placeholder="חיפוש נתיב או שם..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="pr-10 text-lg"
          />
          {searchQuery && (
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm text-muted-foreground">
              {filteredCount} תוצאות
            </span>
          )}
        </div>

        {/* Routes Grid */}
        <div className="space-y-6">
          {filteredRoutes.map((category) => (
            <div key={category.category} className="space-y-3">
              <h2 className="text-lg font-semibold text-foreground border-b border-border pb-2">
                {category.category}
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
                {category.items.map((route) => {
                  const isActive = location.pathname === route.path;
                  return (
                    <Link
                      key={route.path}
                      to={route.path}
                      className={cn(
                        "flex items-center gap-3 p-3 rounded-lg border transition-all",
                        "hover:bg-accent hover:border-primary/50",
                        isActive
                          ? "bg-primary/10 border-primary text-primary"
                          : "bg-card border-border text-foreground"
                      )}
                    >
                      <span className={cn(
                        "p-2 rounded-md",
                        isActive ? "bg-primary/20" : "bg-muted"
                      )}>
                        {route.icon}
                      </span>
                      <div className="flex-1 min-w-0">
                        <div className="font-medium truncate">{route.label}</div>
                        <div className="text-xs text-muted-foreground font-mono truncate">
                          {route.path}
                        </div>
                      </div>
                      {route.protected && (
                        <Lock className="w-3 h-3 text-muted-foreground flex-shrink-0" />
                      )}
                    </Link>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        {/* Legend */}
        <div className="flex items-center gap-4 text-sm text-muted-foreground border-t border-border pt-4">
          <div className="flex items-center gap-1">
            <Lock className="w-3 h-3" />
            <span>דורש התחברות</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded bg-primary/10 border border-primary" />
            <span>נתיב נוכחי</span>
          </div>
        </div>

        {/* Back to Home */}
        <div className="pt-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-primary text-primary-foreground font-medium hover:opacity-90 transition-opacity"
          >
            <Home className="w-5 h-5" />
            חזרה לדף הבית
          </Link>
        </div>
      </div>
    </div>
  );
}
